import About from "./about";
import Contact from "./contact";
import Projects from "./projects";
import Skills from "./skills";

function Main() {
  return (
    <main>
      <Projects />
      <About />
      <Skills />
      <Contact />
    </main>
  );
}
export default Main;
